// フィルターボタン押下、ドロワー表示
const BUTTON_FILTER = document.querySelector(".custom-section-main-collection-product-grid__open");
const MAIN_COLLECTION_PRODUCT_GRID_SECTION_BODY = document.querySelector(
  ".custom-section-main-collection-product-grid__body",
);
try {
  BUTTON_FILTER.addEventListener("click", function () {
    MAIN_COLLECTION_PRODUCT_GRID_SECTION_BODY.classList.toggle("js-filter-active");
    this.classList.toggle("js-filter-active");
  });
} catch (error) {
  console.log(error);
}

// フィルターボタン押下、ドロワー表示(モバイル)
const BUTTON_FILTER_MOBILE = document.querySelector(".mobile-facets__open-wrapper");
const MAIN_COLLECTION_PRODUCT_GRID_SECTION_BODY_MOBILE = document.querySelector(
  ".mobile-facets__disclosure",
);

try {
  BUTTON_FILTER_MOBILE.addEventListener("click", function () {
    document.querySelector("html").classList.toggle("js-mobile-filter-active");
  });
} catch (error) {
  console.log(error);
}

// 絞り込みボタン押下、ドロワー非表示(モバイル)
const BUTTON_FILTER_CLOSE_MOBILE = document.querySelector(".mobile-facets__close");
try {
  BUTTON_FILTER_CLOSE_MOBILE.addEventListener("click", function () {
    document.querySelector("html").classList.remove("js-mobile-filter-active");
  });
} catch (error) {
  console.log(error);
}

const STICKY_HEADER = document.querySelector(
  ".custom-section-main-collection-product-grid__header",
);
const STICKY_ASIDE = document.querySelector(".custom-section-main-collection-product-grid__aside");

// const STICKY_HEADER = MAIN_COLLECTION_PRODUCT_GRID_SECTION_HEADER;
// const STICKY_ASIDE = MAIN_COLLECTION_PRODUCT_GRID_SECTION_ASIDE;

const HEADER = document.querySelector(".header");

let headerAbsolutePosition;
let asideAbsolutePosition;

function calcTargetAbsolutePosition(target) {
  try {
    const TARGET_RECT = target.getBoundingClientRect();
    const ABSOLUTE_POSITION = TARGET_RECT.top + window.pageYOffset;
    return ABSOLUTE_POSITION;
  } catch (error) {
    console.log(error);
  }
}

try {
  headerAbsolutePosition = calcTargetAbsolutePosition(STICKY_HEADER);
  asideAbsolutePosition = calcTargetAbsolutePosition(STICKY_ASIDE);

  window.addEventListener("resize", function () {
    headerAbsolutePosition = calcTargetAbsolutePosition(STICKY_HEADER);
    asideAbsolutePosition = calcTargetAbsolutePosition(STICKY_ASIDE);
  });
} catch (error) {
  console.log(error);
}

try {
  // 指定位置までスクロールさせたら、stickyにする
  window.addEventListener("scroll", function () {
    const HEADER_RECT = STICKY_HEADER.getBoundingClientRect();
    if (HEADER_RECT.top <= 0) {
      STICKY_HEADER.classList.add("js-sticky");
    } else if (this.window.scrollY <= headerAbsolutePosition) {
      STICKY_HEADER.classList.remove("js-sticky");
    }
  });
} catch (error) {
  console.log(error);
}

// 上にスクロール時、ヘッダーの高さ分、コレクションタイトル・asideをずらす
let lastScrollY = window.scrollY;
let headerHeight = HEADER.clientHeight;
let stickyHeaderHeight = STICKY_HEADER.clientHeight;

try {
  window.addEventListener("scroll", function () {
    headerHeight = HEADER.clientHeight;
    const CURRENT_SCROLL_Y = this.window.scrollY;

    // 上にスクロール
    if (CURRENT_SCROLL_Y <= lastScrollY) {
      STICKY_HEADER.style.transform = `translateY(${headerHeight}px)`;
      STICKY_ASIDE.style.top = `${headerHeight + stickyHeaderHeight}px`;
    } else if (CURRENT_SCROLL_Y > lastScrollY) {
      STICKY_HEADER.style.transform = "translateY(0px)";
      STICKY_ASIDE.style.top = `${stickyHeaderHeight}px`;
    }

    // 定位置に戻ったら、ずらした分を戻す
    if (CURRENT_SCROLL_Y <= headerAbsolutePosition) {
      STICKY_HEADER.style.transform = "translateY(0px)";
    }

    lastScrollY = CURRENT_SCROLL_Y;
  });
} catch (error) {
  console.log(error);
}

// スクロールして、コレクションタイトルまで到着するまで、上記のtopからスクロールしたpxを引く
// 上にスクロールしたら、表示されたヘッダーの分だけズラす
try {
  // フィルター上部までの絶対位置を取得し、topに設定(PC)
  STICKY_ASIDE.style.top = `${stickyHeaderHeight}px`;

  window.addEventListener("scroll", function () {
    if (this.window.scrollY <= headerAbsolutePosition) {
      STICKY_ASIDE.style.top = `${stickyHeaderHeight}px`;
    } else if (this.window.scrollY > headerAbsolutePosition) {
      // STICKY_ASIDE.style.top = `${asideAbsolutePosition}px`;
      // console.log("test");
    }
  });
} catch (error) {
  console.log(error);
}

// フィルターの高さを動的にする
let viewHeight = window.innerHeight;
let stickyAsideRelativePosition = STICKY_ASIDE.getBoundingClientRect().top;
let stickyAsideMaxHeight;

function calcMaxHeightTarget(target) {
  viewHeight = window.innerHeight;
  stickyAsideRelativePosition = target.getBoundingClientRect().top;

  return viewHeight - stickyAsideRelativePosition;
}

try {
  window.addEventListener("resize", function () {
    stickyAsideMaxHeight = calcMaxHeightTarget(STICKY_ASIDE);
    STICKY_ASIDE.style.maxHeight = `${stickyAsideMaxHeight}px`;
  });

  window.addEventListener("scroll", function () {
    stickyAsideMaxHeight = calcMaxHeightTarget(STICKY_ASIDE);
    STICKY_ASIDE.style.maxHeight = `${stickyAsideMaxHeight}px`;
  });
} catch (error) {
  console.log(error);
}
